<template>
<span>
    <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
        <v-container fluid>
            <v-row>
                <v-col cols="10" xs="12" sm="12" md="8" lg="10" xl="10">
                    <v-row>
                        <v-col cols="12" class="d-flex flex-row">
                            <v-switch class="mr-10" color="lime" v-model="user.usu_admin" label="Administrador"></v-switch>
                            <v-switch class="mr-10" color="lime" v-model="user.usu_funcionario" label="Funcionário"></v-switch>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-select v-model="user.department_id" :items="departments" item-text="dept_nome" item-value="dept_id" label="Selecione um departamento..." :rules="rules.departmentRules" required outlined></v-select>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="user.usu_nome" :rules="rules.nomeRules" label="Nome" outlined required></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="user.email" :rules="rules.emailRules" label="Email" outlined required></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="user.password" label="Senha" outlined required></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <v-text-field v-model="user.usu_rg" name="usu_rg" label="RG" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <v-text-field v-model="user.usu_cpf" name="usu_cpf" label="CPF" v-mask="'###.###.###-##'" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <v-text-field v-model="user.usu_profissao" name="usu_profissao" label="Cargo" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <v-text-field v-model="user.usu_fone1" label="Telefone" v-mask="'(##) ####-####'" outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                            <v-text-field v-model="user.usu_celular" :rules="rules.celularRules" label="Celular" v-mask="'(##) #-####-####'" outlined></v-text-field>
                        </v-col>

                        <v-col xs12>
                            <v-switch color="lime" v-model="user.usu_status" label="Status"></v-switch>
                        </v-col>

                        <v-col xs12 xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                            <v-btn class="btn-salvar" :disabled="!valid" color="success" @click="onSubmit">
                                <v-icon dark class="mdi mdi-check"></v-icon>{{btnLabel}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="2" xs="12" sm="12" md="4" lg="2" xl="2" class="justify-center">
                    <v-col v-if="preview || user.usu_foto">
                        <v-card>
                            <v-img v-if="preview" class="img-preview" :src="preview">
                            </v-img>

                            <v-img v-if="user.usu_foto && !preview" class="img-preview" :src="`${base_url}upload/user/${user.usu_foto}`">
                            </v-img>

                            <v-card-actions class="justify-center">
                                <v-btn icon>
                                    <v-icon @click="$refs.file.click()">cloud_upload</v-icon>
                                </v-btn>
                                <v-btn icon>
                                    <v-icon @click.prevent="removePreview">highlight_off</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>

                    <v-col class="justify-center">
                        <v-btn v-if="!preview && !user.usu_foto" color="blue-grey" class="btn-upload white--text mt-3" @click="$refs.file.click()">
                            <v-icon class="mdi mdi-cloud-upload mr-2"></v-icon> Adicionar foto
                        </v-btn>
                        <input type="file" ref="file" style="display:none;" id="files" @change="onFileChange" />
                    </v-col>
                </v-col>
            </v-row>

        </v-container>

    </v-form>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../../config/configs'

export default {
    props: {
        user: {
            require: false,
            type: Object | Array,
            default: () => {
                return {
                    usu_id: '',
                    department_id: '',
                    username: '',
                    email: '',
                    usu_nome: '',
                    usu_cnpj: '',
                    usu_ie: '',
                    usu_cpf: '',
                    usu_rg: '',
                    usu_prefixo: '65',
                    usu_fone1: '',
                    usu_celular: '',
                    usu_foto: '',
                    usu_status: true,
                    usu_admin: false,
                    usu_funcionario: true,
                    usu_usuario: false,
                    usu_profissao: ''
                }
            }
        },
        update: {
            require: false,
            type: Boolean,
            default: false
        },
        btnLabel: {
            require: false,
            type: String,
            default: 'Salvar'
        },
        require: true,
    },
    created() {
        this.$store.dispatch('loadDepartmentsActive');
    },
    computed: {
        departments() {
            return this.$store.state.departments.active.data;
        }
    },
    name: "FormUserComponent",

    data() {
        return {
            valid: true,
            rules: {
                nomeRules: [
                    v => !!v || 'Campo Nome é obrigatório',
                    v => (v && v.length <= 200) || 'Nome precisa ter ate 200 Caracteres'
                ],
                departmentRules: [
                    v => !!v || 'Campo Departamento é obrigatório',
                ],
                emailRules: [
                    v => !!v || 'Campo E-Mail é obrigatório',
                    v => /.+@.+/.test(v) || 'E-mail precisa ser válido'
                ],
                prefixoRules: [
                    v => !!v || 'Campo Prefixo é obrigatório',
                    v => (v && v.length == 2) || 'Prefixo deve ter 2 caracteres'
                ],
                foneRules: [
                    v => !!v || 'Campo Telefone é obrigatório',
                ],
            },
            upload: null,
            fileName: 'Selecione uma foto',
            preview: null,
            show: false,
            base_url: URL_BASE
        }
    },
    methods: {
        onSubmit() {

            if (this.$refs.form.validate()) {
                const action = this.update ? 'updateUser' : 'storeUser';
                const msg = this.update ? 'Dados atualizados com sucesso' : 'Cadastro efetuado com sucesso';

                const formData = new FormData();

                if (this.upload !== null)
                    formData.append('usu_foto', this.upload);

                if ((this.user.password !== null) && (this.user.password !== '') && (this.user.password !== undefined)){
                    formData.append('password', this.user.password);
                }

                formData.append('usu_id', this.user.usu_id);
                formData.append('department_id', this.user.department_id);
                formData.append('username', this.user.email);
                formData.append('email', this.user.email);
                formData.append('usu_nome', this.user.usu_nome);
                formData.append('usu_cnpj', this.user.usu_cnpj);
                formData.append('usu_ie', this.user.usu_ie);
                formData.append('usu_cpf', this.user.usu_cpf);
                formData.append('usu_rg', this.user.usu_rg);
                formData.append('usu_fone', this.user.usu_fone);
                formData.append('usu_celular', this.user.usu_celular);
                formData.append('usu_admin', this.user.usu_admin);
                formData.append('usu_funcionario', this.user.usu_funcionario);
                formData.append('usu_usuario', this.user.usu_usuario);
                formData.append('usu_profissao', this.user.usu_profissao);
                formData.append('usu_status', this.user.usu_status);

                this.$store.dispatch(action, formData)
                    .then(() => {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: msg,
                            showConfirmButton: true,
                            timer: 6000
                        });
                        history.back();
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: 'Erro',
                            text: 'Algo deu errado',
                            showConfirmButton: true,
                            timer: 6000
                        });
                        this.errors = error.response.data.errors
                    })
            } else {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: 'Alguns campos requer sua atenção',
                    text: 'Verifique os campos em vermelho',
                    showConfirmButton: true,
                    timer: 6000
                });
            }

        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length)
                return;

            this.upload = files[0];
            this.fileName = this.upload.name;

            this.previewImage(files[0]);
        },
        previewImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.preview = e.target.result;
            };
            reader.readAsDataURL(file)
        },
        removePreview() {
            this.preview = null;
            this.upload = null;
        },
    },
};
</script>

<style scoped>
.theme--dark.v-sheet {
    background-color: #303030;
    border-color: #303030;
    color: #fff;
    box-shadow: none;
}

.btn-upload,
.btn-salvar {
    margin: 0;
}

/*Also*/
.fileinput-button input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    opacity: 0;
    -ms-filter: 'alpha(opacity=0)';
    filter: 'alpha(opacity=0)';
    font-size: 200px;
    direction: ltr;
    cursor: pointer;
}

.img-preview {
    max-width: 100%;
    height: 120px;
}
</style>
